import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { getSalesByMitra } from '../../supabase/database';
import { FaWallet } from 'react-icons/fa';
import Spinner from '../../components/ui/Spinner';

const KomisiPage = () => {
  const { currentUser } = useAuth();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    if (currentUser) {
      // Update logika: ambil sales yang diproses dan dikirim seluruhnya
      Promise.all([
        getSalesByMitra(currentUser.uid, 'diproses'),
        getSalesByMitra(currentUser.uid, 'dikirim seluruhnya')
      ])
        .then(([processedSales, deliveredSales]) => {
          // Gabungkan semua sales yang sudah divalidasi
          const allValidatedSales = [...(processedSales || []), ...(deliveredSales || [])];
          
          // Filter hanya penjualan yang sudah lunas
          const fullyPaidSales = allValidatedSales.filter(sale => sale.pembayaran === 'lunas');
          setSales(fullyPaidSales);
        })
        .finally(() => setLoading(false));
    }
  }, [currentUser]);

  // Komisi dihitung dengan tarif global tetap (15%), tidak per mitra
  const totalKomisi = sales.reduce((acc, sale) => {
    const commissionRate = 15 / 100;
    // Use hargaSetelahDiskon if available, otherwise fallback to subtotal or 0
    const saleAmount = sale.hargaSetelahDiskon || sale.subtotal || 0;
    const komisi = saleAmount * commissionRate;
    return acc + komisi;
  }, 0);

  if (loading) return <Spinner />;

  return (
    <div className="p-4 md:p-8 bg-white min-h-full">
      <div className="flex items-center gap-4 mb-6">
        <FaWallet className="text-4xl text-amber-500" />
        <h1 className="text-3xl font-bold text-gray-800">Rincian Komisi</h1>
      </div>

      <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded-md mb-6">
        <div className="flex justify-between items-center">
          <div>
            <span className="font-bold text-lg">Total Komisi (Pembayaran Lunas)</span>
            <p className="text-sm mt-1">Komisi hanya dihitung dari penjualan yang sudah lunas</p>
          </div>
          <span className="font-bold text-2xl">Rp {totalKomisi.toLocaleString('id-ID', { minimumFractionDigits: 0 })}</span>
        </div>
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Tanggal</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nama Sekolah</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Harga (Stlh Diskon)</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status Pembayaran</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Komisi</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {sales.map(sale => {
              const commissionRate = 15 / 100;
              // Use hargaSetelahDiskon if available, otherwise fallback to subtotal or 0
              const saleAmount = sale.hargaSetelahDiskon || sale.subtotal || 0;
              const komisi = saleAmount * commissionRate;
              return (
                <tr key={sale.id}>
                  <td className="px-6 py-4">
                    {sale.createdAt?.toLocaleDateString ? sale.createdAt.toLocaleDateString('id-ID') : 
                     sale.createdAt ? new Date(sale.createdAt).toLocaleDateString('id-ID') : 'N/A'}
                  </td>
                  <td className="px-6 py-4">{sale.pelanggan?.nama_pelanggan || sale.namaSekolah || 'N/A'}</td>
                  <td className="px-6 py-4">Rp {saleAmount.toLocaleString('id-ID')}</td>
                  <td className="px-6 py-4">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                      Lunas
                    </span>
                  </td>
                  <td className="px-6 py-4 font-bold text-green-600">
                    Rp {komisi.toLocaleString('id-ID', { minimumFractionDigits: 0 })}
                    <span className="text-xs font-normal text-gray-500 ml-1">(15%)</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {sales.length === 0 && <p className="text-center p-4 text-gray-500">Belum ada penjualan yang diproses/dikirim dan lunas.</p>}
      </div>
    </div>
  );
};

export default KomisiPage;
